import { useState } from "react";

const inReplace = "https://s3.timeweb.com/20b52338-storage-ris/";
const fixReplace = "https://storage-v.mypromos.ru/";

const replace = ["https://s3.timeweb.com/20b52338-storage-ris/", "https://storagein.ris.promo/"];
const appType = import.meta.env.MODE;

const ReloadImage = (props) => {
    const [src, setSrc] = useState(!import.meta.env.DEV ? (props.src ? props.src.replace(inReplace, fixReplace) : "") : props.src);
    const [replaceCount, setReplaceCount] = useState(0);
    const [isOnLoad, setIsOnload] = useState(false);

    const onErrorImageLoad = (e) => {
        if (e.type === "error" && replace[replaceCount] && appType !== "development") {
            const newReplace = props.src.replace(inReplace, replace[replaceCount]);
            setSrc(newReplace);
            setReplaceCount(replaceCount + 1);
        }
    };

    const _onLoad = (e) => {
        setIsOnload(true);
    };

    return <img {...props} src={src} onLoad={_onLoad} onError={onErrorImageLoad} />;
};

export default ReloadImage;
